import {HttpClient, HttpParams} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {environment} from "@env/environment";
import {RetailerBillingSummary} from "@features/leasing/billing-details-upload/billing-details-upload.model";

@Injectable({
  providedIn: 'root'
})
export class BillingDetailsUploadService {
  constructor(private http: HttpClient) {
  }

  getSubLeaseDetails(parentUuid: string) {
    let requestParams = new HttpParams()
      .set('parentUuid', parentUuid);
    return this.http.get<RetailerBillingSummary[]>(this.baseRetailersUrl + '/billing-summaries', {params: requestParams});
  }

  get baseRetailersUrl() {
    return environment.apiLeaseHost + `/console/manage-lease/sub-lease`
  }
}
